export const isCloseToBottom = evt => {
  const { layoutMeasurement, contentOffset, contentSize } = evt
  const paddingToBottom = 20

  return (
    layoutMeasurement.height + contentOffset.y >=
    contentSize.height - paddingToBottom
  )
}
